import { render, staticRenderFns } from "./SliderProjects.vue?vue&type=template&id=85fd1382"
import script from "./SliderProjects.vue?vue&type=script&lang=js"
export * from "./SliderProjects.vue?vue&type=script&lang=js"
import style0 from "./SliderProjects.vue?vue&type=style&index=0&id=85fd1382&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports